import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import ThemeContext from '@hig/theme-context';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function stylesheet(props, themeData) {
  function typographyStyle(variant, margin) {
    return {
      color: themeData["typography." + variant + ".color"],
      display: "block",
      fontFamily: themeData["typography." + variant + ".fontFamily"],
      fontSize: themeData["typography." + variant + ".fontSize"],
      fontWeight: themeData["typography." + variant + ".fontWeight"],
      lineHeight: themeData["typography." + variant + ".lineHeight"],
      margin: margin || 0,
      textAlign: "initial"
    };
  }

  var customStylesheet = props.stylesheet;


  var baseStyles = typographyStyle("body", "0 0 " + themeData["density.spacings.small"] + " 0");

  var listStyles = {
    "ul, ol": { paddingLeft: themeData["density.spacings.large"] },
    "ul li": {
      listStyle: "none",

      "&:before": {
        content: "'\\B7'",
        verticalAlign: "middle",
        fontSize: themeData["density.fontSizes.large"],
        paddingRight: themeData["density.spacings.small"],
        marginLeft: "-14px"
      }
    }
  };

  var headerStyles = {
    h1: typographyStyle("h1"),
    h2: typographyStyle("h2"),
    h3: typographyStyle("h3")
  };

  var anchorStyles = {
    a: {
      textDecoration: "none",
      cursor: "pointer",
      color: themeData["textLink.primary.default.fontColor"],
      outline: "none",

      "&:hover": {
        color: themeData["textLink.primary.hover.fontColor"],
        textDecoration: "underline",
        textDecorationColor: themeData["textLink.primary.hover.underlineColor"]
      },

      "&:focus": {
        color: themeData["textLink.primary.focus.fontColor"],
        outline: "solid " + themeData["textLink.focus.haloWidth"] + " " + themeData["textLink.focus.haloColor"]
      }
    }
  };

  var boldStyles = {
    "b, strong": { fontWeight: themeData["basics.fontWeights.bold"] }
  };

  var paragraphStyles = {
    p: typographyStyle("body", "0 0 " + themeData["density.spacings.small"] + " 0"),
    "h1 + p, h2 + p, h3 + p": typographyStyle("body", themeData["density.spacings.medium"] + " 0 " + themeData["density.spacings.small"] + " 0")
  };

  var styles = {
    richText: _extends({}, baseStyles, listStyles, headerStyles, anchorStyles, paragraphStyles, boldStyles)
  };

  return customStylesheet ? customStylesheet(styles, props, themeData) : styles;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichText = function (_Component) {
  _inherits(RichText, _Component);

  function RichText() {
    _classCallCheck(this, RichText);

    return _possibleConstructorReturn(this, (RichText.__proto__ || Object.getPrototypeOf(RichText)).apply(this, arguments));
  }

  _createClass(RichText, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(
        ThemeContext.Consumer,
        null,
        function (_ref) {
          var resolvedRoles = _ref.resolvedRoles;

          var _props = _this2.props,
              children = _props.children,
              dangerouslySetInnerHTML = _props.dangerouslySetInnerHTML,
              otherProps = _objectWithoutProperties(_props, ["children", "dangerouslySetInnerHTML"]);

          var className = otherProps.className;

          var styles = stylesheet(_this2.props, resolvedRoles);
          return children ? React.createElement(
            "div",
            { className: cx(css(styles.richText), className) },
            children
          ) : React.createElement("div", {
            className: cx(css(styles.richText), className),
            dangerouslySetInnerHTML: dangerouslySetInnerHTML // eslint-disable-line react/no-danger
          });
        }
      );
    }
  }]);

  return RichText;
}(Component);

RichText.propTypes = {
  /**
   * React-generated markup to style with HIG typography rules
   */
  children: PropTypes.node,
  /**
   * HTML string to be rendered and styled with HIG typography rules
   */
  dangerouslySetInnerHTML: PropTypes.shape({
    __html: PropTypes.string
  }),
  /**
   * Adds custom/overriding styles
   */
  stylesheet: PropTypes.func
};
RichText.__docgenInfo = {
  "description": "",
  "displayName": "RichText",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "React-generated markup to style with HIG typography rules"
    },
    "dangerouslySetInnerHTML": {
      "type": {
        "name": "shape",
        "value": {
          "__html": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "HTML string to be rendered and styled with HIG typography rules"
    },
    "stylesheet": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Adds custom/overriding styles"
    }
  }
};

export default RichText;
